import { motion, useScroll, useTransform } from "framer-motion";

/**
 * Mascot characters positioned at different scroll-depths.
 * Each character floats with a gentle oscillation AND
 * moves at a different parallax speed when the user scrolls.
 */
const CHARACTERS = [
  {
    src: "/mascot-1.png",
    top: "6%",
    left: "4%",
    width: 160,
    speed: -200,
    rotate: 18,
    floatDuration: 6,
  },
  {
    src: "/mascot-2.png",
    top: "22%",
    left: "80%",
    width: 140,
    speed: 160,
    rotate: -14,
    floatDuration: 7,
  },
  {
    src: "/mascot-3.png",
    top: "44%",
    left: "6%",
    width: 150,
    speed: -140,
    rotate: 12,
    floatDuration: 8,
  },
  {
    src: "/mascot-4.png",
    top: "62%",
    left: "76%",
    width: 170,
    speed: 180,
    rotate: -20,
    floatDuration: 6.5,
  },
  {
    src: "/mascot-5.png",
    top: "82%",
    left: "14%",
    width: 145,
    speed: -120,
    rotate: 15,
    floatDuration: 7.5,
  },
];

function FloatingMascot({ src, top, left, width, speed, rotate, floatDuration }) {
  const { scrollYProgress } = useScroll();

  // Scroll-linked transforms
  const y = useTransform(scrollYProgress, [0, 1], [0, speed]);
  const rot = useTransform(scrollYProgress, [0, 1], [0, rotate]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1, 1.06, 1]);

  return (
    <motion.div
      style={{ top, left, y, rotate: rot, scale }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.2, ease: "easeOut" }}
      className="pointer-events-none absolute select-none"
    >
      {/* Continuous gentle float */}
      <motion.img
        src={src}
        alt=""
        width={width}
        height={width}
        className="opacity-[0.10]"
        animate={{ y: [0, -20, 0] }}
        transition={{
          duration: floatDuration,
          repeat: Infinity,
          repeatType: "reverse",
          ease: "easeInOut",
        }}
        draggable={false}
      />
    </motion.div>
  );
}

export default function TechBackground() {
  return (
    <div
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
      aria-hidden="true"
    >
      {CHARACTERS.map((char, i) => (
        <FloatingMascot key={i} {...char} />
      ))}
    </div>
  );
}
